import jwtDecode from "jwt-decode";
import { v4 as uuidv4 } from "uuid";

//const { usersEndPoint } = config;

export function getSessionID() {
  // Check if unique ID exists in sessionStorage
  let sessionID = localStorage.getItem("sessionID");
  console.log("Retrieved sessionID from sessionStorage:", sessionID); // Debug statement

  if (!sessionID) {
    // Generate unique ID and store it in sessionStorage
    sessionID = uuidv4();
    localStorage.setItem("sessionID", sessionID);
    console.log(
      "Generated new sessionID and stored in sessionStorage:",
      sessionID
    ); // Debug statement
  }
  return sessionID;
}

export function getSessionUser() {
  try {
    const token = sessionStorage.getItem("token");
    if (token != null) {
      const user = jwtDecode(token);
      return user;
    } else {
      return null;
    }
  } catch (ex) {
    console.log("getSessionUser", ex);
    return null;
  }
}
